<template>
    <button @click="onButtonClicked()">{{ cta }}</button>
</template>

<script>
import mktoAnalytics from '../marketo/marketo-analytics';
import stringUtil from '../../../analytics/string-util';

export default {
    props: {
      cta: {
        type: String,
        required: true,
      },
      href: {
        type: String,
        required: true,
      },
    },
    methods: {
      onButtonClicked(){
        mktoAnalytics.setOptimizelyEvents('navTest', 'Click');
        // same ga event as opening lead form
        dataLayer.push({ 
          event: 'popup', 
          fieldValue: stringUtil.toTitleCase(this.cta), 
          popupAction: 'Click', 
          popupType: 'Nav',
        });
        window.location = this.href;
      }
    }
};
</script>